import { Cache } from '@stt-componentes/cache';

export const getHeaders = () => {
	const token = Cache.getAccessToken();
	return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export const getAuthorization = () => {
	const token = Cache.getAccessToken();
	return `Bearer ${token}`;
};
